import isEmpty from "lodash/isEmpty";
import { decamelizeKeys } from "humps";
import { SEARCH_FILTER_TYPES } from "../constants";

export default ({ get, checkStatus, toJSON }) => ({
  search: ({ query, page, pageSize, activeSearchFilters }) => {
    let filtersQuery = "";
    const revisedActiveSearchFilters = {};

    if (!isEmpty(activeSearchFilters)) {
      Object.keys(activeSearchFilters).forEach((filterName) => {
        if (Object.values(SEARCH_FILTER_TYPES).includes(filterName)) {
          revisedActiveSearchFilters[filterName] =
            activeSearchFilters[filterName];
        }
      });
      if (activeSearchFilters.keyword) {
        revisedActiveSearchFilters.keyword = activeSearchFilters.keyword;
      }
      filtersQuery =
        new URLSearchParams(
          decamelizeKeys(revisedActiveSearchFilters),
        ).toString() || "";
    }

    const searchQuery = query?.keyword
      ? `keyword=${query?.keyword}`
      : filtersQuery;

    return get(
      `universe/v1/search/search_by_filters?${searchQuery}&page=${page}&results_per_page=${pageSize}`,
    )
      .then(checkStatus)
      .then(toJSON);
  },
  getSearchFilters: () =>
    get(`universe/v1/search_filters`).then(checkStatus).then(toJSON),
  getSchools: (query) =>
    get(`universe/v1/search/schools_improved/?q=${query}`)
      .then(checkStatus)
      .then(toJSON),
});
